import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Switch = /*#__PURE__*/function (_Component) {
  _inherits(Switch, _Component);
  var _super = _createSuper(Switch);
  function Switch() {
    _classCallCheck(this, Switch);
    return _super.apply(this, arguments);
  }
  _createClass(Switch, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        totalFrames = _this$props.totalFrames,
        activeFrame = _this$props.activeFrame,
        className = _this$props.className;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('dots')
      }, Array.from({
        length: totalFrames
      }).map(function (_, index) {
        return /*#__PURE__*/React.createElement("button", {
          "aria-label": "\u0421\u043B\u0430\u0439\u0434 ".concat(index + 1),
          className: cx('dot', {
            active: index === activeFrame
          }, className),
          key: index,
          onClick: function onClick() {
            return _this.props.onSwitch(index);
          }
        });
      }));
    }
  }]);
  return Switch;
}(Component);
_defineProperty(Switch, "defaultProps", {
  activeFrame: 0,
  totalFrames: 0,
  onSwitch: function onSwitch() {
    return undefined;
  },
  className: null
});
Switch.propTypes = process.env.NODE_ENV !== "production" ? {
  activeFrame: PropTypes.number,
  totalFrames: PropTypes.number,
  onSwitch: PropTypes.func,
  className: PropTypes.any
} : {};